import { useMemo } from 'react';

import { usePetitionUpdatePageData } from '#src/app/pages/petitionUpdate/details/pageContext';
import type { ShareActionsOptions } from '#src/app/shared/hooks/share';

import type { Channel } from './types';
import { useGetShareContent } from './useGetShareContent';
import { useGetShareTrackingData } from './useGetShareTrackingData';
import { useGetShareUrl } from './useGetShareUrl';

export function useShareOptions({ disableShortLinks }: { disableShortLinks: boolean }): ShareActionsOptions<Channel> {
	const getUrl = useGetShareUrl();
	const getContent = useGetShareContent();
	const getTrackingData = useGetShareTrackingData();

	const {
		data: {
			update: {
				petition: { bestStoryShareVisual },
			},
		},
	} = usePetitionUpdatePageData();

	return useMemo(
		() => ({
			disableShortLinks,
			trackingEventName: 'share_update',
			getUrl,
			getContent,
			getTrackingData,
			config: {
				instagramStories: {
					enabled: !!bestStoryShareVisual,
				},
				tiktok: {
					enabled: !!bestStoryShareVisual,
				},
			},
		}),
		[getUrl, getContent, getTrackingData, bestStoryShareVisual, disableShortLinks],
	);
}
